import _slicedToArray from "/data/jenkins/workspace/jd-bi-web/jd-bi-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { Container } from "./container";
import ReactDOM from "react-dom";
import { Executor } from "./executor";
import React, { useEffect, useRef, useState } from "react";
export function createModel(hook) {
  var element = document.createElement("div");
  var container = new Container(hook);
  ReactDOM.render(React.createElement(Executor, {
    onUpdate: function onUpdate(val) {
      container.data = val;
      container.notify();
    },
    hook: hook
  }), element);

  var useModel = function useModel(depsFn) {
    var _useState = useState(function () {
      return container ? container.data : undefined;
    }),
        _useState2 = _slicedToArray(_useState, 2),
        state = _useState2[0],
        setState = _useState2[1];

    var depsFnRef = useRef(depsFn);
    depsFnRef.current = depsFn;
    var depsRef = useRef([]);
    useEffect(function () {
      if (!container) return;

      function subscriber(val) {
        if (!depsFnRef.current) {
          setState(val);
        } else {
          var oldDeps = depsRef.current;
          var newDeps = depsFnRef.current(val);

          if (compare(oldDeps, newDeps)) {
            setState(val);
          }

          depsRef.current = newDeps;
        }
      }

      container.subscribers.add(subscriber);
      return function () {
        container.subscribers.delete(subscriber);
      };
    }, [container]);
    return state;
  };

  Object.defineProperty(useModel, "data", {
    get: function get() {
      return container.data;
    }
  });
  return useModel;
}

function compare(oldDeps, newDeps) {
  if (oldDeps.length !== newDeps.length) {
    return true;
  }

  for (var index in newDeps) {
    if (oldDeps[index] !== newDeps[index]) {
      return true;
    }
  }

  return false;
}